export const DASHBOARD = 'Dashboard'
export const PEOPLE_WE_LOVE = 'PeopleWeLove'
export const LOVE_LANGUAGE = 'LoveLanguage'
export const PROPOSAL = 'Proposal'
export const RELATIONSHIP_STAGES = 'RelationshipStages'
export const HELP_CENTER = 'HelpCenter'
export const ACCOUNT = 'Account'
